import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DefaultLayout from "../../layouts/DefaultLayout";
import { addNewBanner } from "../../redux/actions/bannerActions";
import { toast } from "react-toastify";

function AddBannerScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerTitleError, setBannerTitleError] = useState("");

  const [bannerImageValue, setBannerImageValue] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [bannerImageError, setBannerImageError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const bannerCreate = useSelector((state) => state.createNewBanner);
  const { loadingBannerAdd, errorBannerAdd, successBannerAdd } = bannerCreate;

  const redirect = "/";
  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    }
  }, [navigate, userInfo, dispatch]);

  useEffect(() => {
    if (successBannerAdd) {
      setBannerTitle("");
      setBannerTitleError("");
      setBannerImage("");
      setBannerImageValue("");
      setBannerImageError("");
    }
  }, [successBannerAdd]);

  return (
    <DefaultLayout>
      <div>
        <div className="flex flex-row text-sm items-center my-1">
          {/* home */}
          <a href="/dashboard">
            <div className="flex flex-row  items-center hover:text-black ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
              <span className="mx-1">Dashboard</span>
            </div>
          </a>
          <a href="/banners">
            <div className="flex flex-row  items-center hover:text-black ">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                  />
                </svg>
              </span>
              <div className="">Banners List</div>
            </div>
          </a>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </span>
          <div className="">Create New Banner</div>
        </div>
        {/*  */}
        <div className="py-5 px-4 flex justify-between">
          <h4 className=" uppercase font-semibold text-black dark:text-white">
            New Banner
          </h4>
        </div>
        {/*  */}
        <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
          <div className="my-2 bg-white py-4 px-2 rounded-md">
            {/*  */}

            <div className="flex md:flex-row flex-col  ">
              <div className=" w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Banner Title <strong className="text-danger">*</strong>
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      bannerTitleError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="text"
                    placeholder="Banner Title"
                    value={bannerTitle}
                    onChange={(v) => setBannerTitle(v.target.value)}
                  />
                  <div className=" text-[8px] text-danger">
                    {bannerTitleError ? bannerTitleError : ""}
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="flex md:flex-row flex-col  ">
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Banner Image <strong className="text-danger">*</strong>
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      bannerImageError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="file"
                    placeholder="Banner Image"
                    value={bannerImageValue}
                    onChange={(v) => {
                      setBannerImageValue(v.target.value);
                      setBannerImage(v.target.files[0]);
                    }}
                  />
                  <div className=" text-[8px] text-danger">
                    {bannerImageError ? bannerImageError : ""}
                  </div>
                </div>
              </div>
            </div>

            {/*  */}
            <div className="my-3 ">
              <div className="flex flex-row items-center justify-end my-3">
                <a
                  href="/banners"
                  className="bg-white text-[#0388A6] text-sm px-5 py-3 rounded-full mr-3"
                >
                  Back
                </a>
                <button
                  disabled={loadingBannerAdd}
                  onClick={async () => {
                    var check = true;
                    setBannerTitleError("");

                    setBannerImageError("");

                    if (bannerTitle === "") {
                      setBannerTitleError("These fields are required.");
                      check = false;
                    }

                    if (bannerImageValue === "") {
                      setBannerImageError("These fields are required.");
                      check = false;
                    }

                    if (check) {
                      // setLoadEvent(true);
                      await dispatch(
                        addNewBanner({
                          banner_title: bannerTitle,
                          banner_image: bannerImage,
                        })
                      ).then(() => {});
                      // setLoadEvent(false);
                    } else {
                      toast.error(
                        "Some fields are empty or invalid. please try again"
                      );
                    }
                  }}
                  className="text-white bg-[#0388A6] text-sm px-5 py-3 rounded-full"
                >
                  {loadingBannerAdd ? "Loading ..." : "Create Banner"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default AddBannerScreen;
